import React from 'react';

const Footer = () => {
    return (


        <div className="row bg-black text-white p-3">
            <div className="col-6">
                <p>This is all about us. For further info please contact us</p>
                <p>Contact no: 0198985898</p>
            </div>
            <div className="col-6">
                <p>Copyright is reserved by Food delivery services</p>
                <span>Sign up now!!</span>
            </div>


        </div>


    );
};

export default Footer;

